module.exports = __webpack_public_path__ + "img/avandaro.c5d44365.jpg";